import React, { useEffect } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import "./Home.css";

function TermsAndConditions({ setupNavigation }) {

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/about',
                    text: 'About JustGoRide',
                    icon: 'fas fa-info-circle'
                },
                {
                    path: '/about/contact',
                    text: 'Contact',
                    icon: 'far fa-at'
                },
                {
                    path: '/about/termsandconditions',
                    text: 'Terms and Conditions',
                    icon: 'fas fa-file-signature'
                },
                {
                    path: '/about/privacypolicy',
                    text: 'Privacy Policy',
                    icon: 'fas fa-user-secret'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Terms and Conditions | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="policy row justify-content-center my-4">
            <div className="col-10">
                <img className="about-logo" alt="JustGoRide" src="/resources/images/new-email-logo.png" />
                <div className="page-content-head text-center  mb-5">
                    <h2><span className="head-icon fas fa-file-signature"></span> Site Terms and Conditions</h2>
                    <span>Last Updated: 26/04/2020</span>
                </div>
                <p>
                    This document outlines the responsibilities and obligations of the user
                    (that’s <strong>you</strong>) and JustGoRide (that’s <strong>us</strong>). The various services of
                    this site are referred to collectively as the <strong>Service</strong>.
                </p>
                <p>
                    Your usage of the Service is a direct indication of you acceptance of these
                    Terms and Conditions. We reserve the right to terminate your usage of the
                    Service if we believe that you have not abided to these Terms and Conditions
                    in any way. We also reserve the right to terminate your use of the Service
                    at any time, for any reason, at our sole discretion.
                </p>
                <p>
                    These Terms and Conditions may be modified from time to time without explicit
                    notice to you. For this reason you should review these terms periodically
                    when using the Service.
                </p>
                <h3>In General</h3>
                <p>
                    The use of this website is subject to the following terms of use:
                </p>
                <ul>
                    <li>
                        The content of the pages of this website is for your general information and
                        use only. It is subject to change without notice.
                    </li>
                    <li>
                        Neither we nor any third parties provide any warranty or guarantee as to the
                        accuracy, timeliness, performance, completeness or suitability of the information
                        and materials found or offered on this website for any particular purpose. You
                        acknowledge that such information and materials may contain inaccuracies or errors
                        and we expressly exclude liability for any such inaccuracies or errors to the fullest
                        extent permitted by law.
                    </li>
                    <li>
                        Your use of any information or materials on this website is entirely at your own risk,
                        for which we shall not be liable. It shall be your own responsibility to ensure that
                        any products, services or information available through this website meet your specific
                        requirements.
                    </li>
                    <li>
                        This website contains material which is owned by or licensed to us. This material
                        includes, but is not limited to, the design, layout, look, appearance and graphics.
                        Reproduction is prohibited other than in accordance with the copyright notice, which
                        forms part of these terms and conditions.
                    </li>
                    <li>
                        All trademarks reproduced in this website which are not the property of, or licensed
                        to, the operator are acknowledged on the website.
                    </li>
                    <li>
                        Unauthorised use of this website may give rise to a claim for damages and/or be a
                        criminal offence.
                    </li>
                    <li>
                        From time to time this website may also include links to other websites. These links
                        are provided for your convenience to provide further information. They do not signify
                        that we endorse the website(s). We have no responsibility for the content of the linked
                        website(s).
                    </li>
                    <li>
                        Your use of this website and any dispute arising out of such use of the website is
                        subject to the laws of England, Scotland and Wales.
                    </li>
                </ul>
                <br />
                <h3>Specifically to the services contained within.</h3>
                <br />
                <h3>A Sense Check!</h3>
                <p>
                    Cycling is a potentially hazardous sport and you should exercise caution before
                    riding somewhere that you are unfamiliar with. Make sure you ride within your abilities and that
                    your kit is up to the job. We are not responsible for what you get up to out on the road or trail.
                    This Service is meant as a source of information only and is not here to advise you to do
                    anything that you are not capable of. Please use this Service sensibly and practice caution
                    where necessary. <strong>You engage in any activities at your own risk.</strong>
                </p>
                <h3>Viewing Routes</h3>
                <p>
                    All of the data that is provided in the Route Viewer is automated either by us or using
                    third party services. As a result we cannot guarantee the accuracy of the information
                    provided and as such you should only ever use the information as a guide and in no way rely
                    solely upon it.  Just because the weather forecast is saying that it’s going to be sunny or
                    the points of interest state that there is a bike shop in the middle of a trail doesn’t mean
                    that there is. Please take this into consideration before you set off.
                </p>
                <h3>Downloading Route Files</h3>
                <p>
                    We provide a download service for GPX Route Files so that you can use them with a GPS Device
                    for Navigation.
                </p>
                <p>
                    We cannot guarantee the accuracy of the GPX Route Files that you download from the service.
                    It is your responsibility to check the GPX Route file to ensure that it is fit for your
                    purposes. This is a community site and the route data is uploaded by the users within the
                    community. There are many different ways of generating a GPX Route File, some of which are
                    more accurate than others. Take time to closely examine a route before you ride it to ensure
                    that you are aware of its accuracy and any potential points of confusion during its navigation.
                </p>
                <p>
                    Please be aware of the legal implications of riding on private land and footpaths. In a nutshell,
                    you should not be doing it and if a route on this site includes sections that crosses private land
                    or navigates onto footpaths it is your repsonsibiltiy to be aware of this and abide by the law.
                </p>
                <p>
                    <strong>You must always have a backup plan just in case the route is inaccurate or your GPS fails.
                    Take a map of the route and ensure someone knows where you are going!</strong>
                </p>
                <h3>Uploading Content</h3>
                <p>
                    <strong>When you upload a route or a ride data file to the website you maintain ownership and therefore the
                    copyright of that content.</strong>
                </p>
                <p>
                    When you upload content to the Service, you retain all of your ownership rights for your uploaded content.
                    However, by submitting this content to JustGoRide, you hereby grant us a worldwide, non-exclusive,
                    royalty-free, sublicense and transferable license to use, reproduce, distribute, prepare derivative works of,
                    display, and perform the content in connection with the JustGoRide site and related or successive
                    businesses, in any media formats, through any channels.
                </p>
                <p>
                    You may terminate our license to your content at any time by requesting that the content be deleted. This can be
                    done through the settings in your user profile by requesting the removing of your account from the site.
                    In most cases this is actioned immediately. 
                </p>
                <p>
                    Content made available on the Service is for <strong>personal, non-commercial use only</strong>. You may
                    not violate our users' rights by reproducing this content through any automated or manual means
                    without express written permission.
                </p>
                <h3>Creating Routes</h3>
                <p>
                    The Route Creator on JustGoRide includes an option to autoplot routes. You must proceed with caution to ensure that the service
                    is routing appropriately as the service merely suggests a path but should not be viewed in any way as a recommendation. The same
                    rules apply that you should double check the route before riding it to ensure that you can safely navigate your ride.
                </p>
                <p>
                    There is also a hiking option on the Route Creator which enables both an alternative use of the tool for walks and hiking but also the facility
                    to safely bridge your route between cycleways. If you choose to use this feature as part of your route planning please ensure that you detail
                    as such in the route description and ride responsibly by dismounting on these sections of the route. 
                </p>
                <h3>Group Creation and Moderation</h3>
                <p>
                    All Groups created within JustGoRide must be self moderated by the owner and administrators appointed by the owner. Public Groups
                    can attract individuals who's participation in Group activity can be seen as divisive. This is unavoidable and must be controlled in order
                    to comply with the rules below. Please consider this when creating a new Group and only open it up to the public if you are prepared to
                    moderate the content and look after the members within your Group. If in any doubt please create Groups as Closed Public Groups requiring users
                    to request membership. This will allow a level of vetting to take place before admittance to the Group.
                </p>
                <p>
                    If inappropriate Group behaviour becomes out of administative control, JustGoRide will step in to help the Group owners and administrators. Please be aware that
                    this will most likely result in temporary Group suspension whilst the issue is resolved as JustGoRide has limited resources to deal with such conflict. This
                    should be viewed as a last resort and every effort should be made to control issues before they escalate. 
                </p>
                <h3>User/Group Timelines, Posts and Comments </h3>
                <p>
                    User reviews, posts and comments are an important part of the website where you can give commentary on the content on
                    the site and the routes that you have knowledge of. This form of commentary is not a forum for writing anything you
                    like though. Destructive comments and reviews will be removed at the discretion of JustGoRide without
                    the need for justification. 
                </p>
                <p>A few rules:</p>
                <ul>
                    <li>No posts which, in our opinion, are likely to cause offence to either an individual, or group, whatever their gender, sexual inclination or ethnicity.</li>
                    <li>No posts, including links to other sites that are deemed to be of a sexual or distasteful nature, incite racial or sexist behaviour or are in any way
                    discriminatory and/or offensive towards individuals or minority groups.</li>
                    <li>No abusive or foul language</li>
                    <li>No posts which in our opinion are solely intended to, or are likely to provoke or abuse any individual or group.</li>
                    <li>No Trade or business advertising</li>
                </ul>
                <h3>Support & Questions</h3>
                <p>
                    If you have any questions regarding these Terms and Conditions or any other features offered within the Service, please
                    contact admin@justgoride.co.uk and we'll be happy to help.
                </p>

            </div>
        </div>
    );

}

TermsAndConditions.propTypes = {
    setupNavigation: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);   




// WEBPACK FOOTER //
// ./src/components/TermsAndConditions.js